import React from "react";
import PropTypes from "prop-types";
import Toolbar from "@material-ui/core/Toolbar";

import Emoji from "../Emoji.js";
import "./css/EnhancedTableToolbar.css";

let EnhancedTableToolbar = (props) => {
  const { title, icon } = props;

  return (
    <Toolbar style={{ paddingTop: "10px", display: "block" }}>
      <h1 className="title-text">{title}</h1>
      {icon && <Emoji symbol={icon} className="title-icon" />}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default EnhancedTableToolbar;
